import { NewUserPatientScreen } from "@/features/auth/screens/NewUserPatientScreen";
import { newUserIndexRouteSearchSchema } from "@/features/auth/search/authRouteSearch";
import { createFileRoute } from "@tanstack/react-router";

const NewUserPatient = () => {
    const { email } = Route.useSearch();
    return <NewUserPatientScreen email={email} />;
};

export const Route = createFileRoute("/_auth/new-user/patient/")({
    component: NewUserPatient,
    validateSearch: (search) => newUserIndexRouteSearchSchema.parse(search ?? {}),
});
